<template >
  <b-container class="mt-4">
    <div class="mt-4 text-center">
      <b-row v-for="(privacy, index) in getPrivacyPolicy" :key="index">
        <b-card
          border-variant="primary"
          header="Primary"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
          class="w-100"
        >
          <template v-slot:header>
            <b-row>
              <b-col></b-col>
              <b-col>{{`${privacy.language} Version`}}</b-col>
              <b-col></b-col>
            </b-row>
          </template>
          <b-card-text v-html="privacy.content"></b-card-text>
        </b-card>
      </b-row>
    </div>
  </b-container>
</template>


<script>
export default {
  computed: {
    getPrivacyPolicy() {
      return this.$store.getters.getPrivacyPolicy;
    }
  },

  created() {
    this.$store.dispatch("setPrivacyPolicy");
  }
};
</script>

